import firebase from 'firebase/app'
import auth from '@/firebase/auth'
import db from '@/firebase/firestore'

const state = {
    team: '',
    teams: [],
}

const getters = {
    teams: (state) => state.teams,
}

const mutations = {
    ADD_TEAM: (state, payload) => {
        state.teams.push(payload)
    },
    ADD_TEAMS: (state, payload) => {
        state.teams = payload
    },
    EDIT_TEAM: (state, payload) => {
        state.teams = state.teams.map(team => {
            if (team.uid === payload.uid) {
                return {
                    ...team,
                    ...payload,
                }
            }

            return team
        })
    },
    DELETE_TEAM: (state, uid) => {
        state.teams = state.teams.filter(team => team.uid !== uid)
    },
}

const actions = {
    loadTeams: ({ commit }) => {
        const list = []

        auth
            .currentUser
            .getIdTokenResult()
            .then(userData => {
                db
                    .collection(`${userData.claims.db}/teams/teams`)
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            list.push({
                                ...doc.data(),
                                uid: doc.id,
                            })
                        })

                        list.sort((a, b) => {
                            const aActive = a.active || false
                            const bActive = b.active || false

                            return aActive < bActive
                                ? 1
                                : aActive > bActive
                                    ? -1
                                    : 1
                        })
                    })
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'team/index.js', 54, err))
                commit('ADD_TEAMS', list)
            })
            .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'team/index.js', 57, err))
    },
    createTeam: ({ commit }, payload) => {
        const data = {
            ...payload.form,
            active: true,
            createdUser: auth.currentUser.uid,
            createdDate: firebase.firestore.FieldValue.serverTimestamp(),
        }

        auth
            .currentUser
            .getIdTokenResult()
            .then(userData => {
                db
                    .collection(`${userData.claims.db}/teams/teams`)
                    .add(data)
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'index.js', 73, err))
                commit('ADD_TEAM', data)
            })
            .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'team/index.js', 76, err))
    },
    editTeam: ({ commit }, payload) => {
        const data = {
            uid: payload.uid,
            ...payload.form,
            updatedUser: auth.currentUser.uid,
            updatedDate: firebase.firestore.FieldValue.serverTimestamp(),
        }

        auth
            .currentUser
            .getIdTokenResult()
            .then(userData => {
                db
                    .collection(`${userData.claims.db}/teams/teams`)
                    .doc(data.uid)
                    .update(data)
                    .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'index.js', 94, err))

                commit('EDIT_TEAM', data)
            })
            .catch(err => console.log('%c%s:%i', 'color: darkgreen', 'team/index.js', 98, err))
    },
    inactivateTeam: ({ dispatch }, uid) => {
        const payload = {
            uid,
            form: {
                active: false,
            },
        }

        dispatch('editTeam', payload)
    },
    activateTeam: ({ dispatch }, uid) => {
        const payload = {
            uid,
            form: {
                active: true,
            },
        }

        dispatch('editTeam', payload)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
